import React from 'react';
import { Typography } from 'antd';
// Types
import { GetCampaignOffers_getCampaignOffers_entities } from 'api/campaignV2/types/GetCampaignOffers';

// Components
import DeliverablesSubmitTimeline from 'components/common/SocialCampaignV2Components/DeliverablesSubmitTimeline/DeliverablesSubmitTimeline';
// Styles
import styles from './SubmitTimelineDeliverables.module.scss';

const { Text } = Typography;

type SubmitTimelineDeliverablesProps = {
  offer: GetCampaignOffers_getCampaignOffers_entities | null;
  refetch?: () => void;
};

const SubmitTimelineDeliverables: React.FC<SubmitTimelineDeliverablesProps> = ({
  offer,
  refetch,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Text className={styles.headerTitle}>Deliverables Timeline</Text>
      </div>

      <DeliverablesSubmitTimeline offer={offer} refetch={refetch} />
    </div>
  );
};

export default SubmitTimelineDeliverables;
